import { useContext, useState } from "react"
import { ModalContext } from "../../../components/contexts/ModalContext"
import BaseHeadBanner from "../../../components/elements/BaseHeadBanner"
import BasePage from "../../../components/layout/BasePage"
import { PlusCircle } from "lucide-react"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { GeneralQueryKeys, LocalStorageKeys } from "../../../api/constants"
import { getKeysPaginate } from "../api/apiCalls"
import ErrorPage from "../../404/ErrorPage"
import Loading from "../../../components/common/Loading"
import BaseGrowBody from "../../../components/elements/BaseGrowBody"
import BaseTable, { ColumnType } from "../../../components/elements/BaseTable"
import { Pagination } from "antd"
import { getDataFromSessionStorage } from "../../../services/functions"
import AddKeyCollectionModal from "../components/AddKeyCollectionModal"
import KeyTableRow from "../components/KeyTableRow"
import { KeycollectionType } from "../../Objekte/types/types"
import { useDeleteKeyMutation } from "../api/services"

export default function KeyPage() {
    const queryClient = useQueryClient()
    const modalCon = useContext(ModalContext)

    // Variables for Pagination
    const [page, setpage] = useState(getDataFromSessionStorage(LocalStorageKeys.KEY_FILTER + "page") ?? 1)
    const handlePageChange = (page: number) => {
        sessionStorage.setItem(LocalStorageKeys.KEY_FILTER + "page", JSON.stringify(page))
        setpage(page)
    }

    // Get Data Query
    const { data, isLoading, error } = useQuery({
        queryKey: [GeneralQueryKeys.KEYS_ALL, page],
        queryFn: () => getKeysPaginate({ page: page, limit: 20 }),
    })

    const [selectedKey, setSelectedKey] = useState<KeycollectionType | null>(null)

    const { mutate: deleteKey } = useDeleteKeyMutation(queryClient, GeneralQueryKeys.KEYS_ALL)

    if (isLoading) return <Loading />
    if (error) return <ErrorPage />

    const columns: ColumnType[] = [{ label: "ID" }, { label: "Anzahl" }, { label: "Schlüssel" }, { label: "Besitzer" }, { label: "" }]

    return (
        data && (
            <BasePage>
                <BaseHeadBanner title="Schlüssel" button={<PlusCircle className="w-6 h-6 cursor-pointer" onClick={() => modalCon?.trigger(1)} />} />
                <BaseGrowBody>
                    <BaseTable
                        columns={columns}
                        tbody={data?.docs?.map((item: any) => (
                            <KeyTableRow
                                keyItem={item}
                                openKeyModal={() => {
                                    setSelectedKey(item)
                                    modalCon?.trigger(1)
                                }}
                                deleteKey={(e: any) => {
                                    e.stopPropagation()
                                    console.log(item._id)
                                    deleteKey(item._id)
                                }}
                            />
                        ))}
                    />
                </BaseGrowBody>
                <div className="flex justify-center w-full p-4">
                    <Pagination pageSize={20} defaultCurrent={1} current={page} onChange={handlePageChange} total={data?.totalDocs} showSizeChanger={false} />
                </div>
                <AddKeyCollectionModal modalId={1} closeModal={() => modalCon?.trigger(1)} selectedKey={selectedKey} />
            </BasePage>
        )
    )
}
